import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-7e342885"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("転職希望"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("アンケート")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "書類作成", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類提出", -1))
const _hoisted_8 = { class: "p-recommend-inner --narrow-gap" }
const _hoisted_9 = { class: "l-wrapper_nav" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

import { getCareerInfoResumeService } from '@/api/services/trnCareerService';
import store from '@/store';
import { CareerResumeInfoDetail, Field, QualificationLanguageDetail } from '@/types';
import { onMounted, ref } from 'vue';
import { MstMyPageItem, MstOccupation3 } from '@/types/mstMyPage';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import CommonFieldList from './components/CommonFieldList.vue';
import { useRouter } from 'vue-router';
import Loading from '@/components/Loading.vue';
import { getMstNameByIdService } from '../../api/services/mstMyPageService';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateResumeView',
  setup(__props) {

const colonSpace = MYPAGE_CONSTANTS.STRING.COLON_SPACE;

const router = useRouter();
const isLoading = ref<boolean>(false);

function scrollToTop() {
  domHelperUtils.scrollToTop();
}
const basicInfoFields = ref<Field[]>([
  { key: 'addressInfo', label: '住所', hidden: true, required: false, value: '' },
  { key: 'nearestStation', label: '最寄駅', hidden: true, required: false, value: '' },
  { key: 'stationToHome', label: '最寄駅～自宅', hidden: true, required: false, value: '' },
  { key: 'residenceType', label: '住居区分', hidden: true, required: false, value: '' },
  { key: 'annualIncome', label: '現年収', hidden: true, required: false, value: '' },
  { key: 'spouse', label: '配偶者', hidden: true, required: true, value: '' },
  { key: 'specialSkills', label: '趣味・特技など', hidden: true, required: false, value: '' },
  { key: 'wishOthers', label: '本人希望記入欄', hidden: true, required: false, value: '' },
  { key: 'name', label: '氏名', hidden: true, required: true, value: '' },
  { key: 'birthday', label: '生年月日', hidden: true, required: false, value: '' },
  { key: 'gender', label: '性別', hidden: true, required: false, value: '' },
  { key: 'tel', label: '電話番号', hidden: true, required: false, value: '' },
  { key: 'email', label: 'メールアドレス', hidden: true, required: false, value: '' },
  { key: 'otherContacts', label: 'その他の連絡先', hidden: true, required: false, value: '' },
]);

const jobSummaryFields = ref<Field[]>([
  { key: 'currentStatus', label: '現在の状況', hidden: true, required: false, value: '' },
  { key: 'experiencedIndustry', label: '経験業種', hidden: true, required: false, value: '' },
  { key: 'experiencedOccupation', label: '経験職種', hidden: true, required: true, value: '' },
  { key: 'experienceCompanies', label: '経験社数', hidden: true, required: false, value: '' },
  { key: 'managementExperience', label: 'マネジメント', hidden: true, required: false, value: '' },
  { key: 'summary', label: '職務要約', hidden: true, required: true, value: '' },
  { key: 'skillsKnowledge', label: '活かせる経験・知識・技術', hidden: true, required: false, value: '' },
  { key: 'PRYourSelf', label: '自己PR', hidden: true, required: false, value: '' },
]);

const workExperienceFields = ref<Field[]>([
  { key: 'companyName', label: '経験企業1', hidden: true, required: false, value: '' },
  { key: 'companyName2', label: '経験企業2', hidden: true, required: false, value: '' },
  { key: 'companyName3', label: '経験企業3', hidden: true, required: false, value: '' }
]);

const educationFields = ref<Field[]>([
  { key: 'finalEducation', label: '最終学歴', hidden: true, required: false, value: '' },
  { key: 'academicBackground', label: '学歴', hidden: true, required: false, value: '' },
]);

const qualificationFields = ref<Field[]>([
  { key: 'qualification', label: '資格名', hidden: true, required: false, order: 1, value: '', subOrder: 0 },
  { key: 'qualOther', label: 'その他特記すべき事項', hidden: true, required: false, order: 2, value: '', subOrder: 0 },
  { key: 'english', label: '語学-英語', hidden: true, required: false, order: 3, value: '', subOrder: 0 },
  { key: 'language', label: '言語', hidden: true, required: false, order: 4, value: '', subOrder: 0 },
  { key: 'langMemo', label: '語学について補足', hidden: true, required: false, order: 5, value: '', subOrder: 0 },
]);

const salaryLabels = {
  annual: '年収',
  monthly: '月収',
  bonus: '年間賞与'
} as const;

const companyLabels = {
  companyName: '企業名',
  period: '勤務期間',
  department: '部署名',
  jobDescription: '職務内容',
  employmentType: '雇用形態',
  officialPosition: '役職',
  annualIncome: '年収',
  reasonForChangingJobs: '転職理由',
  companyIndustry: '企業の業種',
  businessContent: '事業内容',
  capital: '資本金',
  numOfEmployees: '従業員数',
  foreignCapitalClassification: '上場・外資区分',
  foreignCapital: '外資'
} as const;

const qualificationLabels = {
  name: '資格名',
  acquisitionYearAndMonth: '資格取得年月'
} as const;

// Mark label required or entered 
const basicInfoRequiredFields = ref<boolean>(false);
const jobSummaryRequiredFields = ref<boolean>(false);
const workExperienceRequiredFields = ref<boolean>(false);
const educationRequiredFields = ref<boolean>(false);

// Data for attributes 
const mstEntrances = ref<MstMyPageItem[]>([]);
const mstGraduations = ref<MstMyPageItem[]>([]);
const mstLicenses = ref<MstMyPageItem[]>([]);
const mstOtherLanguages = ref<MstMyPageItem[]>([]);
const mstLanguageLevels = ref<MstMyPageItem[]>([]);
const mstSex = ref<MstMyPageItem[]>([]);
const mstWkStatus = ref<MstMyPageItem[]>([]);
const mstPeopleManagement = ref<MstMyPageItem[]>([]);
const mstPeopleManagementYear = ref<MstMyPageItem[]>([]);
const mstListed = ref<MstMyPageItem[]>([]);
const mstIndustry = ref<MstMyPageItem[]>([]);
const mstIndustryYearCategory = ref<MstMyPageItem[]>([]);
const mstOccupation3 = ref<MstOccupation3[]>([]);
const mstEmpType = ref<MstMyPageItem[]>([]);


const JP_SPACE = '　';
const YES = 'あり';
const NO = 'なし';
const storeBase = MYPAGE_CONSTANTS.STORE_MST;
// Formats a zipcode string as "XXX-XXXX"
const formatZipCode = (zipcode: string) => {
  if (zipcode.length === 0) return '';
  // Ensure input is a string and format with hyphen after third digit
  const zipStr = String(zipcode);
  return zipStr.slice(0, 3) + '-' + zipStr.slice(3, 7);
};

// Fetches and formats walk/bus information with time in minutes
const formatWalkBus = async (id: number, walkBusTime: number) => {
  if ((walkBusTime === null || walkBusTime === 0) && !id) return '';
  if (id === 0 && walkBusTime) return walkBusTime + '分';
  // Fetch walk/bus name from master data
  const walkBusName = await getMstNameByIdService(id, storeBase.MST_WALK_BUS, store);
  if (walkBusName) {
    return walkBusName + (walkBusTime ? `${walkBusTime}分` : '');
  }
  return '';
};

// Fetches and returns residential classification text from master data
const formatResidentialClassification = async (id: number) => {
  if (!id || id === 0) return '';
  return await getMstNameByIdService(id, storeBase.MST_INHABIT_TYPE, store);
};

// Fetches and returns station name from master data
const formatStationName = async (id: number) => {
  if (!id || id === 0) return '';
  return await getMstNameByIdService(id, storeBase.MST_STATION, store);
};

/**
 * Formats address information for display.
 * @param zipCode Postal code
 * @param prefId Prefecture ID
 * @param addr1 Address line 1
 * @param addr2 Address line 2
 * @returns Formatted address string
 */
const formatAddress = async (
  zipCode: string | null,
  prefId: number | null,
  addr1: string | null,
  addr2: string | null
): Promise<string> => {
  // Address parts for the second line
  const addressParts: string[] = [];
  // Fetch prefecture name if ID is provided
  if (prefId) {
    const prefName = await getMstNameByIdService(prefId, storeBase.MST_PREF, store);
    if (prefName) {
      addressParts.push(prefName);
    }
  }
  // Add address line 1 and 2 if provided
  if (addr1) {
    addressParts.push(addr1);
  }
  if (addr2) {
    addressParts.push(addr2);
  }
  // Create the second line of address
  const addressLine = addressParts.join(JP_SPACE);
  // If zipCode exists, display in the first line, address in the second line (no leading space)
  if (zipCode) {
    const zip = formatZipCode(zipCode);
    return addressLine
      ? `${zip}<br/>${addressLine}`
      : `${zip}<br/>`;
  }

  // If zipCode does not exist, just show the address line
  return addressLine;
};

// Formats a gender string
const formatSex = (id: number) => {
  if (!id || id === 0) return '';
  return mstSex?.value?.filter(v => v.id === id).map(v => v.text)[0] ?? '';
};

// Formats the full name and full name in kana, separated by a line break if both are present
const formatName = (firstName: string, lastName: string, firstNameKana: string, lastNameKana: string) => {
  let fullName = '';
  let fullNameKana = '';
  if (firstName || lastName) {
    fullName = '氏名' + colonSpace + lastName + (!!lastName && !!firstName ? JP_SPACE : '') + firstName;
  }
  if (firstNameKana || lastNameKana) {
    fullNameKana = '氏名カナ' + colonSpace + lastNameKana + (!!lastNameKana && !!firstNameKana ? JP_SPACE : '') + firstNameKana;
  }
  // Add a line break only if kana exists
  return fullName + (fullName.length > 0 ? '<br/>' : '') + fullNameKana;
};

// Formats annual income with labels, showing amounts in 万円
const formatAnnualIncome = async (
  annual: number, monthly: number, bonus: number,
  allowanceId1: number | null, allowanceId2: number | null, allowanceId3: number | null, allowanceId4: number | null,
  allowanceNum1: number | null, allowanceNum2: number | null, allowanceNum3: number | null, allowanceNum4: number | null
) => {
  const data = await store.dispatch(storeBase.MST_ALLOWANCE) as MstMyPageItem[];
  let i = 0;
  const values = { annual, monthly, bonus };
  const keys = Object.keys(values) as (keyof typeof salaryLabels)[];
  const arrAnnualIncome = keys.filter(key => values[key] != null).map(key => `${salaryLabels[key]}${colonSpace}${values[key]}万円`);

  const allowanceIds = [allowanceId1, allowanceId2, allowanceId3, allowanceId4];
  const allowanceNums = [allowanceNum1, allowanceNum2, allowanceNum3, allowanceNum4];
  for (i = 0; i < allowanceIds.length; i++) {
    if (allowanceIds[i] && allowanceNums[i] != null) {
      const annualIncome = data.find(obj => obj.id === allowanceIds[i]);
      if (annualIncome) {
        arrAnnualIncome.push(`${annualIncome.text}${colonSpace}${allowanceNums[i]}万円`);
      }
    }
  }


  // Join each label and value with line breaks
  return arrAnnualIncome.join('<br/>');
};

// Formats spouse info, spouse support obligation, and dependents
const formatSpouseInfo = (spouseFlg: number, spouseSPFlg: number, dependentsNum: number) => {
  // If all are falsy, return empty string
  if (!spouseFlg && !spouseSPFlg && !dependentsNum) return '';

  const details: string[] = [];

  if (spouseFlg) {
    details.push(`配偶者${colonSpace}${spouseFlg === 1 ? YES : NO}`);
  }
  if (spouseSPFlg) {
    details.push(`配偶者の扶養義務${colonSpace}${spouseSPFlg === 1 ? YES : NO}`);
  }
  if (dependentsNum) {
    details.push(`扶養家族（配偶者を除く）${colonSpace}${dependentsNum}人`);
  }

  return details.join('<br/>');
};

// Formats telephone numbers, separated by line break if both are present
const formatTelephone = (tel1: string, tel2: string): string => {
  const numbers: string[] = [];
  if (tel1) numbers.push(tel1);
  if (tel2) numbers.push(tel2);
  return numbers.length ? numbers.join(' <br/> ') : '';
};

// Formats email addresses, with labels and line break if both are present
const formatEmail = (mail1: string, mail2: string): string => {
  const emails: string[] = [];
  if (mail1) emails.push(`メールアドレス1${colonSpace}${mail1}`);
  if (mail2) emails.push(`メールアドレス2${colonSpace}${mail2}`);
  return emails.length ? emails.join('<br/>') : '';
};

// Formats a date string as Japanese date format (YYYY 年 MM月DD 日)
const formatJapaneseDate = (date: string | undefined) => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (!(d instanceof Date) || isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}年${month}月${day}日`;
};

// Formats a date string as "YYYY年MM月DD日"
const formatDate = (dateValue: string): string => {
  const date = new Date(dateValue);

  // Check for invalid date
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}年${month}月${day}日`;
};

// Formats a start and end date into a readable string (e.g., "YYYY/MM/DD 〜 YYYY/MM/DD")
const formatStartAndEndDate = (start: string, enb: string, from: string, to: string) => {
  const dStart = formatDate(start); // '' if invalid
  const dEnd = formatDate(enb);     // '' if invalid
  // If both are missing, return ''
  if (!dStart && !dEnd) return '';
  let res = '';
  if (dStart) {
    res = `${dStart}${from ? ' ' + from : ''}`;
  }
  res += ' 〜 ';
  if (dEnd) {
    res += `${dEnd}${to ? ' ' + to : ''}`;
  }
  return res;
};

// Retrieves WkStatus name from master table by ID
const formatWkStatusName = (wkStatusId: number) => {
  if (!wkStatusId || wkStatusId === 0) return '';
  return mstWkStatus?.value?.filter(v => v.id === wkStatusId).map(v => v.text)[0] ?? '';
};

// Formats company info with labels and line breaks
const formatCompanyInfo = (
  companyName: string,
  period: string,
  department: string,
  jobDescription: string,
  employmentType: string,
  officialPosition: string,
  annualIncome: string,
  reasonForChangingJobs: string,
  companyIndustry: string,
  businessContent: string,
  capital: string,
  numOfEmployees: string,
  foreignCapitalClassification: string): string => {
  if (!companyName) {
    return '';
  }
  const values = { companyName, period, department, jobDescription, employmentType, officialPosition, annualIncome, reasonForChangingJobs, companyIndustry, businessContent, capital, numOfEmployees, foreignCapitalClassification };
  return Object.keys(values)
    .filter(key => values[key as keyof typeof values] != null && values[key as keyof typeof values] !== '')
    .map(key => `${companyLabels[key as keyof typeof companyLabels]}${colonSpace}${values[key as keyof typeof values]}`)
    .join('<br/>');
};

/**
 * Formats experienced industry information.
 * @param indsctgId Industry category ID
 * @param indsctgYearId Industry experience year ID
 * @returns Formatted string of industry and experience year
 */
const formatExperiencedIndustry = (
  industryCategoryId: number,
  industryYearCategoryId: number | null
) => {
  const industryCategoryName = getIndustryName(industryCategoryId);
  // Both industry name and year category exist
  if (industryCategoryName && industryYearCategoryId) {
    const industryYearCategoryName = getIndustryYearCategoryName(industryYearCategoryId);
    return `${industryCategoryName}${JP_SPACE}${industryYearCategoryName}`;
  }
  // Only industry name exists
  if (industryCategoryName) {
    return industryCategoryName;
  }
  // Special case: both IDs are falsy and year ID is zero
  if (!industryCategoryId && industryYearCategoryId === 0) {
    return '0年';
  }

  // If nothing exists
  return '';
};

/**
 * Fetches and returns the industry year category name by its ID.
 * @param categoryId Industry year category ID
 * @returns The year category name, or an empty string if not found
 */
const getIndustryYearCategoryName = (categoryId: number) => {
  // Return empty string if categoryId is falsy (undefined, null, 0, etc.)
  if (!categoryId) return '';
  // Fetch the year category object by ID
  const yearCategory = mstIndustryYearCategory.value.find(v => v.id === categoryId);
  // Return the name if available
  if (yearCategory && yearCategory.id) {
    return yearCategory.text;
  }
  // Return empty string if not found
  return '';
};

/**
 * Fetches and returns the industry name by its ID.
 * @param industryId Industry category ID
 * @returns The industry name, or an empty string if not found
 */
const getIndustryName = (industryId: number) => {
  // Return empty string if industryId is falsy
  if (!industryId) return '';
  // Fetch the industry object by ID
  const industryCategory = mstIndustry.value.find(v => v.id === industryId);
  // Return the industry name if available
  if (industryCategory && industryCategory.id) {
    return industryCategory.text;
  }
  // Return empty string if not found
  return '';
};

/**
 * Retrieves the employment type name from the master table by its ID.
 * @param empTypeId Employment type ID
 * @returns Employment type name, or empty string if not found
 */
const getEmpTypeName = (empTypeId: number) => {
  if (!empTypeId) return '';
  const empType = mstEmpType.value.find(item => item.id === empTypeId);
  return empType?.text ?? '';
};

/**
 * Formats all experienced industries from a career info object.
 * @param careerInfo CareerResumeInfoDetail object containing industry IDs and year IDs
 * @returns Formatted industry names with year info, separated by line breaks; empty string if none
 */
const formatExperiencedIndustries = (careerInfo: CareerResumeInfoDetail) => {
  if (!careerInfo) return '';

  // List of [industryId, yearCategoryId] pairs from the careerInfo object
  const industryYearPairs = [
    [careerInfo.expIndsCtg1Id, careerInfo.expIndSctg1YearsId],
    [careerInfo.expIndsCtg2Id, careerInfo.expIndSctg2YearsId],
    [careerInfo.expIndsCtg3Id, careerInfo.expIndSctg3YearsId],
    [careerInfo.expIndsCtg4Id, careerInfo.expIndSctg4YearsId],
    [careerInfo.expIndsCtg5Id, careerInfo.expIndSctg5YearsId],
    [careerInfo.expIndsCtg6Id, careerInfo.expIndSctg6YearsId],

  ];
  const formattedIndustries: string[] = [];
  // Iterate over each pair and format if industryId exists
  for (const [industryId, yearCategoryId] of industryYearPairs) {
    if (industryId) {
      const formatted = formatExperiencedIndustry(industryId, yearCategoryId);
      if (formatted) {
        formattedIndustries.push(formatted);
      }
    }
  }

  // Return the formatted result, each separated by a line break
  return formattedIndustries.length > 0 ? formattedIndustries.join('<br/>') + '<br/>' : '';
};

/**
 * Formats all experienced occupations from a career info object.
 * @param careerInfo CareerResumeInfoDetail object containing occupation IDs and year IDs
 * @returns Formatted occupation names with year info, separated by line breaks; empty string if none
 */
const formatExperiencedOccupations = (careerInfo: CareerResumeInfoDetail) => {
  if (!careerInfo) return '';

  // List of [occupationId, yearCategoryId] pairs from the careerInfo object
  const occupationYearPairs = [
    [careerInfo.expOcupcTg1Id, careerInfo.expOcupCtg1YearsId],
    [careerInfo.expOcupcTg2Id, careerInfo.expOcupCtg2YearsId],
    [careerInfo.expOcupcTg3Id, careerInfo.expOcupCtg3YearsId],
    [careerInfo.expOcupcTg4Id, careerInfo.expOcupCtg4YearsId],
    [careerInfo.expOcupcTg5Id, careerInfo.expOcupCtg5YearsId],
    [careerInfo.expOcupcTg6Id, careerInfo.expOcupCtg6YearsId],
  ];

  const formattedOccupations: string[] = [];
  // Iterate each pair, format if occupationId exists
  for (const [occupationId, yearCategoryId] of occupationYearPairs) {
    if (occupationId) {
      const formatted = formatExperiencedOccupation(
        String(occupationId),
        Number(yearCategoryId)
      );
      if (formatted) {
        formattedOccupations.push(formatted);
      }
    }
  }

  // Return the formatted result, each separated by a line break
  return formattedOccupations.length > 0
    ? formattedOccupations.join('<br/>') + '<br/>'
    : '';
};


// Returns a formatted string of occupation and occupation-year category
const formatExperiencedOccupation = (occupationId: string, occupationYearId: number) => {
  if (!occupationId) return '';
  const occupation = mstOccupation3.value.find(v => v.ocupctgid === occupationId);
  // If occupation is not found or ocup3classid is missing, return ''
  if (!occupation || !occupation.ocup3classid) return '';
  // If occupationYearId is provided, fetch year category
  if (occupationYearId) {
    const industryYearCategory = mstIndustryYearCategory.value.find(v => v.id === occupationYearId);
    if (industryYearCategory && industryYearCategory.id) {
      return `${occupation.ocup3classname}${JP_SPACE}${industryYearCategory.text}`;
    }
  }

  // If occupationYearId not provided, just return occupation name
  return occupation.ocup3classname;
};

/**
 * Formats a company count as a string with the Japanese "社" unit.
 * @param num Number of companies
 * @returns Formatted string (e.g. "3社"), or empty string if null
 */
const formatExperienceCompanies = (num: number) => {
  if (num === null) return '';
  return `${num}社`;
};


/**
 * Formats an education date and additional info as a string.
 * @param year Graduation/acquisition year (e.g. 2020)
 * @param month Graduation/acquisition month (e.g. 3)
 * @param note Additional information (e.g. "卒業", "取得")
 * @returns Formatted string (e.g. "2020年3月[note]"), or empty string if year or month is missing
 */
const formatEducationTimes = (year: number, month: number, note: string) => {
  if (!year || !month) return note??'';
  return `${year}年${month}月${note}`;
};

/**
 * Formats education information as a labeled string.
 * @param schoolName School name (searched or direct input)
 * @param facultyDepartment Faculty/department name
 * @param admission Admission info (e.g. "2017年4月入学")
 * @param graduation Graduation info (e.g. "2021年3月卒業")
 * @returns Formatted string with labels, separated by line breaks
 */
const formatEducationInfo = (
  schoolName: string,
  facultyDepartment: string,
  admission: string,
  graduation: string
) => {
  // Decide label for school name based on input format
  let schoolNameLabel = '学校名(検索)';
  if (
    schoolName &&
    !schoolName.includes('<br/>') &&
    schoolName.startsWith('学校名(直接)' + colonSpace)
  ) {
    schoolNameLabel = '学校名(直接)';
    // Remove the prefix and any extra spaces
    schoolName = schoolName.replace('学校名(直接)' + colonSpace, '').trim();
  }

  // Define display fields with labels
  const displayFields: { label: string; value: string }[] = [
    { label: schoolNameLabel, value: schoolName },
    { label: '学部学科', value: facultyDepartment },
    { label: '入学', value: admission },
    { label: '卒業', value: graduation },
  ];

  // Filter out empty fields, format as "label：value", and join with line breaks
  return displayFields
    .filter(field => field.value != null && field.value !== '')
    .map(field => `${field.label}${colonSpace}${field.value}`)
    .join('<br/>');
};

/**
 * Retrieves the entrance name from the master table by ID.
 * @param entranceId Entrance event ID
 * @returns The entrance name, or an empty string if not found
 */
const formatEntranceName = (entranceId: number) => {
  // Find the entrance object by ID (prefer find over filter/map for performance)
  const entrance = mstEntrances?.value?.find(v => v.id === entranceId);
  return entrance?.text ?? '';
};

/**
 * Retrieves the graduation name from the master table by ID.
 * @param graduationId Graduation event ID
 * @returns The graduation name, or an empty string if not found
 */
const formatGraduationName = (graduationId: number) => {
  // Find the graduation object by ID
  const graduation = mstGraduations?.value?.find(v => v.id === graduationId);
  return graduation?.text ?? '';
};

/**
 * Formats a qualification name and acquisition date as a labeled string.
 * @param name Qualification name (nullable)
 * @param acquisitionYearAndMonth Acquisition year/month (nullable)
 * @returns Formatted string with labels, separated by line breaks
 */
const formatQualification = (
  name: string | null,
  acquisitionYearAndMonth: string | null,
): string => {
  const formattedItems: string[] = [];

  // Add qualification name if provided
  if (name) {
    formattedItems.push(`${qualificationLabels.name}${colonSpace}${name}`);
  }

  // Add acquisition year/month if provided
  if (acquisitionYearAndMonth) {
    formattedItems.push(`${qualificationLabels.acquisitionYearAndMonth}${colonSpace}${acquisitionYearAndMonth}`);
  }

  // Join items with line breaks
  return formattedItems.join('<br/>');
};

/**
 * Returns the license text for a given license ID, or an empty string if not found.
 * @param licenseId License ID
 * @returns License text or empty string
 */
const formatLicense = (licenseId: number) => {
  const license = mstLicenses.value.find(x => x.id === licenseId);
  return license?.text ?? '';
};

/**
 * Formats the acquisition year and month as "YYYY年MM月".
 * If both year and month are missing, returns an empty string.
 * @param year Acquisition year
 * @param month Acquisition month
 * @returns Formatted string or empty string
 */
const formatAcquisitionYearAndMonth = (year: number, month: number) => {
  if (!year && !month) return '';
  return `${year}年${month}月`;
};

/**
 * Returns the language text for a given other language ID, or an empty string if not found.
 * @param languageId Other language ID
 * @returns Language text or empty string
 */
const formatOtherLanguage = (languageId: number) => {
  const language = mstOtherLanguages.value.find(x => x.id === languageId);
  return language?.text ?? '';
};

/**
 * Returns the language level text for a given language level ID, or an empty string if not found.
 * @param languageLevelId Language level ID
 * @returns Language level text or empty string
 */
const formatLanguageLevel = (languageLevelId: number) => {
  const level = mstLanguageLevels.value.find(x => x.id === languageLevelId);
  return level?.text ?? '';
};

/**
 * Returns the people management year text for a given ID, or an empty string if not found.
 * @param managementYearId People management year ID
 * @returns Management year text or empty string
 */
const formatPeopleManagementYear = (managementYearId: number) => {
  const year = mstPeopleManagementYear.value.find(x => x.id === managementYearId);
  return year?.text ?? '';
};

/**
 * Returns the people management text for a given ID, or an empty string if not found.
 * @param managementId People management ID
 * @returns Management text or empty string
 */
const formatPeopleManagement = (managementId: number) => {
  const management = mstPeopleManagement.value.find(x => x.id === managementId);
  return management?.text ?? '';
};

/**
 * Gets the listed type name and adds the "Foreign Capital" label if applicable.
 * @param id Listed type ID
 * @param isForeignCapital Foreign capital flag (1: foreign, 0: not foreign)
 * @returns Listed type name (e.g. "TSE Prime (Foreign)", "(Foreign)", "TSE Prime", or "")
 */
const formatListed = (id: number, isForeignCapital: number) => {
  // Find the listed type name by ID
  const listedName =
    mstListed.value.find(x => x.id === id)?.text ?? '';

  // If the name exists and is foreign capital, add the label
  if (listedName && isForeignCapital === 2) {
    return `${listedName} (外資)`;
  }
  // If there is no name but is foreign capital, show only the label
  if (!listedName && isForeignCapital === 2) {
    return '(外資)';
  }
  // Otherwise, just return the name (may be empty)
  return listedName;
};

/**
 * Maps each field's value and hidden status based on the provided data object.
 * @param fields Array of Field objects (each with 'key', 'value', 'hidden' properties)
 * @param data Record of key-value pairs to map to fields
 */
const mapFieldsWithData = (fields: Field[], data: Record<string, any>) => {
  fields.forEach(field => {
    // Assign value from data, or empty string if not present
    field.value = data[field.key] ?? '';
    // Hide the field if value is empty
    field.hidden = !field.value;
  });
};

/**
 * Formats management experience information as a labeled string.
 * @param value Experience flag (1: Yes, 2: No, 0/undefined: blank)
 * @param managementPeopleId People management ID (for number of people)
 * @param managementYearId People management year ID (for years)
 * @returns Formatted string with line breaks, or NO/blank
 */
const formatYesNo = (
  value: number,
  managementPeopleId: number,
  managementYearId: number
): string => {
  // Return empty if value is falsy or zero
  if (!value || value === 0) return '';

  // If value is 1 (Yes)
  if (value === 1) { // 1 = Yes, 2 = No
    let result = `マネジメント経験${colonSpace}${YES}`;
    // Append management people info if available
    const peopleText = managementPeopleId ? formatPeopleManagement(managementPeopleId) : '';
    if (peopleText) {
      result += `<br/>マネジメント人数${colonSpace}${peopleText}`;
    }
    // Append management year info if available
    const yearText = managementYearId ? formatPeopleManagementYear(managementYearId) : '';
    if (yearText) {
      result += `<br/>マネジメント年数${colonSpace}${yearText}`;
    }
    return result;
  }

  // If value is not 1 (i.e. 2: No), return NO
  return NO;
};

/**
 * Formats a string by replacing newlines with <br/>, or returns the number as-is.
 * Returns an empty string if the value is null, undefined, or falsy.
 * @param value String or number to format
 * @returns Formatted string or number
 */
const formatWithBr = (value: string | number | null | undefined) => {
  if (typeof value === 'number') return value;
  if (!value) return '';
  // Replace all types of line breaks with <br/>
  return value.replace(/(\r\n|\n|\r)/g, '<br/>');
};

/**
 * Formats English qualification details such as TOEIC, TOEFL, and English level.
 * @param qual QualificationLanguageDetail object
 * @returns Formatted string with qualification info, separated by line breaks
 */
const formatEnglishQual = (qual: QualificationLanguageDetail) => {
  if (!qual) return '';

  const formattedRecords: string[] = [];

  // TOEIC score and acquisition date
  if (qual.toeic) {
    let toeicInfo = `TOEIC${colonSpace}${qual.toeic}点`;
    if (qual.toeicY && qual.toeicM) {
      toeicInfo += ` ${qual.toeicY}年${qual.toeicM}月取得`;
    }
    formattedRecords.push(toeicInfo);
  } else if (qual.toeicY && qual.toeicM) {
    // Only acquisition date exists
    formattedRecords.push(`TOEIC${colonSpace}${qual.toeicY}年${qual.toeicM}月取得`);
  }

  // TOEFL score and acquisition date
  if (qual.toefl) {
    let toeflInfo = `TOEFL${colonSpace}${qual.toefl}点`;
    if (qual.toeflY && qual.toeflM) {
      toeflInfo += ` ${qual.toeflY}年${qual.toeflM}月取得`;
    }
    formattedRecords.push(toeflInfo);
  } else if (qual.toeflY && qual.toeflM) {
    // Only acquisition date exists
    formattedRecords.push(`TOEFL${colonSpace}${qual.toeflY}年${qual.toeflM}月取得`);
  }

  // English level
  if (qual.qualEnglishLevelId) {
    const englishLevelText = formatLanguageLevel(qual.qualEnglishLevelId);
    if (englishLevelText) {
      formattedRecords.push(`英語レベル${colonSpace}${englishLevelText}`);
    }
  }

  // Join all formatted records with <br/>
  return formattedRecords.join('<br/>');
};

/**
 * Concatenates the field name and field number.
 * @param fieldName Base field name
 * @param fieldNum Field number
 * @returns Combined field name (e.g. "expIndsCtg1")
 */
const formatFieldName = (fieldName: string, fieldNum: number) => {
  return `${fieldName}${fieldNum}`;
};

/**
 * Formats a number as Japanese yen in units of ten thousand ("万円").
 * Returns an empty string for falsy values.
 * @param amount Amount in ten thousand yen units
 * @returns Formatted string (e.g. "500万円") or empty string
 */
const formatYenJPY = (amount: number): string => {
  if (!amount) return '';
  return `${amount}万円`;
};

/**
 * Formats a number as a person count in Japanese ("人").
 * Returns an empty string for falsy values.
 * @param count Number of people
 * @returns Formatted string (e.g. "3人") or empty string
 */
const formatPersonJP = (count: number): string => {
  if (!count) return '';
  return `${count}人`;
};

/**
 * Navigates to the '/recommend' tab if the interview date is valid, in the future or today,
 * and the previous route was not in the set of resume-related routes.
 * @param interviewDate - The interview date to compare against the current date/time.
 */
const navigateToRecommendIfUpcomingInterview = (comingInterviewDate: boolean, acceptedApplication: boolean) => {
  const previousRouteName = store.getters['router/previousRoute']?.name ?? '';
    // q00: recommend, c03: submitadvisor, c01: resume-form
  const cameFromResumeRoute = ['q00', 'c03', 'c01'].includes(previousRouteName);
  if (acceptedApplication && !comingInterviewDate) {
    comingInterviewDate = false;
  }

  if (!acceptedApplication && !comingInterviewDate) {
    comingInterviewDate = true;
  }
  // Only navigate if interviewDate is valid, upcoming/today, and not coming from resume routes
  if (comingInterviewDate && !cameFromResumeRoute) {
    router.push({ path: '/recommend' });
  }
};

/**
 * Fetch masters data
 */
const fetchMstData = async () => {
  mstEntrances.value = await store.dispatch(storeBase.MST_ENTRANCE);
  mstGraduations.value = await store.dispatch(storeBase.MST_GRADUATION);
  mstLicenses.value = await store.dispatch(storeBase.MST_LICENSES);
  mstOtherLanguages.value = await store.dispatch(storeBase.MST_OTRLANG);
  mstLanguageLevels.value = await store.dispatch(storeBase.MST_LANGUAGE_LEVEL);
  mstSex.value = await store.dispatch(storeBase.MST_SEX);
  mstWkStatus.value = await store.dispatch(storeBase.MST_WK_STATUS);
  mstPeopleManagement.value = await store.dispatch(storeBase.MST_PEOPLE_MANAGEMENT);
  mstPeopleManagementYear.value = await store.dispatch(storeBase.MST_PEOPLE_MANAGEMENT_YEAR);
  mstListed.value = await store.dispatch(storeBase.MST_LISTED);
  mstIndustry.value = await store.dispatch(storeBase.MST_INDUSTRY);
  mstIndustryYearCategory.value = await store.dispatch(storeBase.MST_YEAR_CATEGORY);
  mstOccupation3.value = await store.dispatch(storeBase.MST_OCUP3);
  mstEmpType.value = await store.dispatch(storeBase.MST_EMPTYPE);
};

onMounted(async () => {
  isLoading.value = true;
  const careerInfo = await getCareerInfoResumeService();
  navigateToRecommendIfUpcomingInterview(careerInfo.comingInterviewDate, careerInfo.acceptedApplication ?? false);
  await fetchMstData();
  if (careerInfo) {
    // Map careerInfo to basic info fields 
    const basicInfoDataMapped = {
      gender: formatSex(careerInfo.sexFlg),
      wishOthers: formatWithBr(careerInfo.wishOthers),
      specialSkills: careerInfo.hobbySkill,
      spouse: formatSpouseInfo(
        careerInfo.spousePresenceFlg,
        careerInfo.spouseObligationFlg,
        careerInfo.dependentsNum ?? 0
      ),
      addressInfo: await formatAddress(
        careerInfo.zipId ?? '',
        careerInfo.prefId ?? 0,
        careerInfo.addr1 ?? '',
        careerInfo.addr2 ?? ''
      ),
      nearestStation: await formatStationName(careerInfo.nearestStationId ?? 0),
      stationToHome: await formatWalkBus(Number(careerInfo.walkBusFlg), careerInfo.walkBusTime ?? 0),
      residenceType: await formatResidentialClassification(careerInfo.inhabitTypeId),
      annualIncome: await formatAnnualIncome(
        careerInfo.currentAnnualIncomeNum,
        careerInfo.monthlyAnnualIncomeNum,
        careerInfo.yearBonus,
        careerInfo.allowanceId1,
        careerInfo.allowanceId2,
        careerInfo.allowanceId3,
        careerInfo.allowanceId4,
        careerInfo.allowanceNum1,
        careerInfo.allowanceNum2,
        careerInfo.allowanceNum3,
        careerInfo.allowanceNum4
      ),
      name: formatName(
        careerInfo.firstName ?? '',
        careerInfo.lastName ?? '',
        careerInfo.firstNameKana ?? '',
        careerInfo.lastNameKana ?? ''
      ),
      birthday: formatJapaneseDate(careerInfo.birthDate),
      tel: formatTelephone(careerInfo.telHome ?? '', careerInfo.telCellular ?? ''),
      email: formatEmail(careerInfo.emailHome ?? '', careerInfo.emailCellular ?? ''),
      loginID: careerInfo.emailHome, // TODO: Confirm mapping for loginID field
      otherContacts: await formatAddress(
        careerInfo.otherZipId ?? '',
        careerInfo.otherPrefId ?? 0,
        careerInfo.otherAddr1 ?? '',
        careerInfo.otherAddr2 ?? ''
      ),
    };
    //  Set each field's value and hidden state 
    mapFieldsWithData(basicInfoFields.value, basicInfoDataMapped);
    //  Set required flag based on zipId and annual income 
    basicInfoRequiredFields.value = !!careerInfo.zipId && !!careerInfo.prefId
      && !!careerInfo.addr1 && !!careerInfo.addr2 && !!careerInfo.birthDate
      && !!careerInfo.firstName && !!careerInfo.lastName && !!careerInfo.firstNameKana && !!careerInfo.lastNameKana
      && !!careerInfo.telHome && !!careerInfo.emailHome && (careerInfo.currentAnnualIncomeNum ?? 0) > 0;

    // Job Summary
    const jobSummaryDataMapped = {
      currentStatus: formatWkStatusName(careerInfo.workStatusId),
      experiencedIndustry: formatExperiencedIndustries(careerInfo),
      experiencedOccupation: formatExperiencedOccupations(careerInfo),
      experienceCompanies: formatExperienceCompanies(careerInfo.expCompNum),
      managementExperience: formatYesNo(careerInfo.managementFlg, careerInfo.managementPeopleId ?? 0, careerInfo.managementYearId ?? 0),
      summary: careerInfo.jobSummary,
      skillsKnowledge: careerInfo.expKnowledgeAbility,
      PRYourSelf: careerInfo.selfPr
    };
    //  Set Job Summary Field Values 
    mapFieldsWithData(jobSummaryFields.value, jobSummaryDataMapped);
    //  Required Fields Logic 
    jobSummaryRequiredFields.value = (
      ((careerInfo.workStatusId !== null && careerInfo.workStatusId > 0 && careerInfo.workStatusId <= 2) && careerInfo.workStatusId > 0) &&
      !!careerInfo.expIndsCtg1Id && !!careerInfo.expOcupcTg1Id)
      && (careerInfo.managementFlg != 1 || (!!careerInfo.managementPeopleId && !!careerInfo.managementYearId));

    // WorkExperiences
    //  Retrieve up to company records with required fields 
    const companies = careerInfo.busicrDetails;
    //  Format work experiences 
    const workExperiences: string[] = [];
    for (const company of companies) {
      const wk = formatStartAndEndDate(company.wkPeriodsDate ?? '', company.wkPeriodeDate ?? '', company.fromClassification ?? '', company.toClassification ?? '');
      const employmentTypeName = getEmpTypeName(company.empTypeId ?? 0);
      const industryName = getIndustryName(company.indsctgId ?? 0);
      const listedName = formatListed(company.listedId ?? 0, company.frigncptlFlg ?? 1);
      const info = formatCompanyInfo(
        company.compName ?? '',
        wk,
        company.dept ?? '',
        company.wkContents ?? '',
        employmentTypeName,
        company.post ?? '',
        formatYenJPY(company.annualIncm ?? 0),
        company.quitRsn ?? '',
        industryName,
        company.busiContents ?? '',
        formatYenJPY(company.capital ?? 0),
        formatPersonJP(company.employeeNum ?? 0),
        listedName);
      if (info) {
        workExperiences.push(info);
      }
    }

    //  Set work experience fields 
    workExperienceFields.value.forEach((field, i) => {
      if (i < workExperiences.length) {
        field.value = workExperiences[i];
        field.hidden = false;
      } else {
        field.value = '';
        field.hidden = true;
      }
    });

    //  Set required flag for work experience fields
    const maxWorkExperiences = careerInfo.busicrDetails.filter(v => v.compName && v.wkPeriodsDate && !!v.fromClassification && v.indsctgId) ?? 0;
    workExperienceRequiredFields.value = ((maxWorkExperiences.length === careerInfo.busicrDetails.length) && careerInfo.busicrDetails.length > 0);

    // Education
    //  Fetch and format education data
    let lastSchoolName = await getMstNameByIdService(careerInfo.lastSchoolId, storeBase.MST_LSTSCHL, store);
    // Create formatted education details array
    const educationDetails: string[] = await Promise.all(
      careerInfo.schlcrDetails
        // Filter out entries with any missing/empty required fields
        .map(async education => {
          const admission = formatEducationTimes(
            education.entranceYr,
            education.entranceMon,
            formatEntranceName(education.entranceFlg)
          );
          const graduation = formatEducationTimes(
            education.gradYr,
            education.gradMon,
            formatGraduationName(education.gradFlg)
          );
          let schoolName = '';
          if (education && education.schlId) {
            schoolName = await getMstNameByIdService(education.schlId, storeBase.MST_SCHOOL, store);
          }

          if (education.schlName) {
            // If schoolName already has content, add a line break before appending
            if (schoolName) {
              schoolName += '<br/>';
            }
            schoolName += '学校名(直接)' + colonSpace + education.schlName;
          }
          // If you want to use the fetched schoolName, use `schoolName` instead of `education.schlName`
          return formatEducationInfo(
            schoolName,
            education.schlDeptName,
            admission,
            graduation
          );
        })
    );
    //  Set field values for display 
    educationFields.value.forEach(field => {
      if (field.key === 'finalEducation') {
        // If last school exists, set its name
        if (lastSchoolName) {
          // Append '(理系)' if science flag is set
          if (careerInfo.scienceFlg === 1) {
            lastSchoolName += '(理系)';
          }
          field.value = lastSchoolName;
          field.hidden = false;
        } else if (careerInfo.scienceFlg === 1) {
          // If no school name, but science flag is set, show only '(理系)'
          field.value = '(理系)';
          field.hidden = false;
        }

      } else if (field.key === 'academicBackground' && educationDetails.length > 0) {
        educationDetails.forEach((v, k) => {
          const educationField = {
            key: formatFieldName(field.key, k + 1),
            label: formatFieldName(field.label, k + 1), hidden: false, required: false, value: v
          };
          educationFields.value.push(educationField);
        });
      } else {
        // Hide unused fields
        field.value = '';
        field.hidden = true;
      }
    });
    //  Set required flag for education fields 
    educationRequiredFields.value = careerInfo.lastSchoolId === 0 ? false : true;


    //  Qualification Mapping 
    const qualificationDetails: string[] = careerInfo.qualDetails.map(qual =>
      formatQualification(
        formatLicense(Number(qual.licenseId)),
        formatAcquisitionYearAndMonth(qual.qualYr, qual.qualMon)
      )
    );

    qualificationFields.value.forEach((field) => {
      // Qualification fields
      if (field.key === 'qualification') {
        qualificationDetails.forEach((v, k) => {
          const educationField = {
            key: formatFieldName(field.key, k + 1),
            label: formatFieldName(field.label, k + 1), 
            hidden: !v, 
            required: false, 
            order: field.order, 
            value: v,
            subOrder: k
          };
          qualificationFields.value.push(educationField);
        });
      }
      // Other qualification field
      if (field.key === 'qualOther') {
        field.value = careerInfo.qualOther;
        field.hidden = !careerInfo.qualOther;
        return;
      }
      if (field.key === 'english') {
        const en = formatEnglishQual(careerInfo.qualLangDetail);
        field.value = en;
        field.hidden = en.length === 0;
        return;
      }
      // Language fields (language1, language2, language3)
      if (field.key === 'language') {
        for (let i = 1; i <= 3; i++) {
          const langId = careerInfo.qualLangDetail[`otrLang${i}Id` as keyof typeof careerInfo.qualLangDetail];
          const langLevel = careerInfo.qualLangDetail[`otrLang${i}LevelId` as keyof typeof careerInfo.qualLangDetail];
          const other = formatOtherLanguage(Number(langId) || 0);
          const v = other + (other ? '<br/>' : '') + formatLanguageLevel(Number(langLevel));
          field.hidden = !field.value;
          const languageField = {
            key: formatFieldName(field.key, i),
            label: formatFieldName(field.label, i), 
            hidden: v.length === 0, 
            required: false, 
            order: field.order, 
            value: v,            
            subOrder: i
          };
          qualificationFields.value.push(languageField);
        }
      }
      // Language memo field
      if (field.key === 'langMemo') {
        field.value = formatWithBr(careerInfo.qualLangDetail.engMemo);
        field.hidden = !careerInfo.qualLangDetail.engMemo;
        return;
      }
    });
    // Sort Qualifications 
    qualificationFields.value.sort((a, b) => {
      if (a.order && b.order && a.order !== b.order) {
        return a.order - b.order;
      }
      else
      {
        if (a.subOrder && b.subOrder && a.subOrder !== b.subOrder) {
          return a.subOrder - b.subOrder;
        }
      }
    });
  
  }
  isLoading.value = false;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/recommend/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/resume/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/resume/submitadvisor/",
              "active-class": "-is-current",
              "exact-active-class": "-is-current"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CommonFieldList, {
            "header-group": "基本情報",
            fields: basicInfoFields.value,
            "is-required-fields": basicInfoRequiredFields.value,
            "is-show-lable": true,
            "edit-url": "/resume/form/?tab=basic-info"
          }, null, 8, ["fields", "is-required-fields"]),
          _createVNode(CommonFieldList, {
            "header-group": "職務要約",
            fields: jobSummaryFields.value,
            "is-required-fields": jobSummaryRequiredFields.value,
            "is-show-lable": true,
            "edit-url": "/resume/form/?tab=worksummary"
          }, null, 8, ["fields", "is-required-fields"]),
          _createVNode(CommonFieldList, {
            "header-group": "職務経歴",
            fields: workExperienceFields.value,
            "is-show-lable": true,
            "is-required-fields": workExperienceRequiredFields.value,
            "edit-url": "/resume/form/?tab=workexperience"
          }, null, 8, ["fields", "is-required-fields"]),
          _createVNode(CommonFieldList, {
            "header-group": "学歴",
            fields: educationFields.value,
            "is-required-fields": educationRequiredFields.value,
            "is-show-lable": true,
            "edit-url": "/resume/form/?tab=education"
          }, null, 8, ["fields", "is-required-fields"]),
          _createVNode(CommonFieldList, {
            "header-group": "資格・語学",
            fields: qualificationFields.value,
            "is-required-fields": true,
            "is-show-lable": false,
            "edit-url": "/resume/form/?tab=qualifications"
          }, null, 8, ["fields"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_12, 8, _hoisted_10)
    ])
  ]))
}
}

})